import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "asm" }
const _hoisted_2 = { class: "asm-head" }
const _hoisted_3 = { class: "asm-av-wrap" }
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "asm-head-info" }
const _hoisted_7 = { class: "asm-name" }
const _hoisted_8 = { class: "asm-role" }
const _hoisted_9 = { class: "asm-email" }
const _hoisted_10 = {
  key: 0,
  class: "asm-atend-badge"
}
const _hoisted_11 = { class: "asm-stats" }
const _hoisted_12 = { class: "asm-stat" }
const _hoisted_13 = { class: "asm-stat-v" }
const _hoisted_14 = { class: "asm-stat" }
const _hoisted_15 = {
  class: "asm-stat-v",
  style: {"color":"var(--blue)"}
}
const _hoisted_16 = { class: "asm-stat" }
const _hoisted_17 = {
  class: "asm-stat-v",
  style: {"color":"#FF6600"}
}
const _hoisted_18 = { class: "asm-stat" }
const _hoisted_19 = {
  class: "asm-stat-v",
  style: {"color":"var(--green)"}
}
const _hoisted_20 = { class: "asm-stat" }
const _hoisted_21 = { class: "asm-stat-v" }
const _hoisted_22 = { class: "asm-stat" }
const _hoisted_23 = { class: "asm-stat-v" }
const _hoisted_24 = {
  key: 0,
  class: "asm-teams"
}
const _hoisted_25 = { class: "asm-convs-wrap" }
const _hoisted_26 = { class: "asm-convs-title" }
const _hoisted_27 = { class: "asm-convs-count" }
const _hoisted_28 = {
  key: 0,
  class: "asm-empty"
}
const _hoisted_29 = {
  key: 1,
  class: "asm-conv-list"
}
const _hoisted_30 = { class: "asm-conv-id" }
const _hoisted_31 = { class: "asm-conv-contact" }
const _hoisted_32 = { class: "asm-conv-name" }
const _hoisted_33 = { class: "asm-conv-phone" }
const _hoisted_34 = { class: "asm-conv-team" }
const _hoisted_35 = ["onClick"]

import { computed } from 'vue'
import type { Conversation } from '@/types/dashboard'
import { avatarColor, initials, fmtDuration } from '@/composables/useHelpers'
import { profileLabel } from '@/composables/useAdmin'

interface AgentData {
  id: number
  name: string
  email: string
  role: string
  teamIds?: number[]
  thumbnail: string
  availability: string
  conversations: Conversation[]
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AgentSummaryModal',
  props: {
    data: {}
  },
  emits: ["close", "openChat"],
  setup(__props: any) {

const props = __props


const openCount    = computed(() => props.data.conversations.filter(c => c.status === 'open').length)
const pendingCount = computed(() => props.data.conversations.filter(c => c.status === 'pending').length)
const resolvedCount = computed(() => props.data.conversations.filter(c => c.status === 'resolved').length)

const resolutionRate = computed(() => {
  const total = props.data.conversations.length
  if (!total) return '—'
  return Math.round((resolvedCount.value / total) * 100) + '%'
})

const avgTime = computed(() => {
  const resolved = props.data.conversations.filter(c => c.status === 'resolved' && c.resolved_at > 0)
  if (!resolved.length) return '—'
  const avg = resolved.reduce((s, c) => s + (c.resolved_at - c.created_at), 0) / resolved.length
  return fmtDuration(avg)
})

const teamNames = computed(() => {
  const s = new Set(props.data.conversations.map(c => c.team?.name).filter(Boolean) as string[])
  return [...s]
})

function statusLabel(s: string) {
  const map: Record<string, string> = { open: 'Aberta', resolved: 'Resolvida', pending: 'Pendente', snoozed: 'Adiada' }
  return map[s] || s
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", {
      class: "asm-backdrop",
      onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.$emit('close')), ["self"]))
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", {
              class: "asm-av",
              style: _normalizeStyle({ background: _unref(avatarColor)(__props.data.name) })
            }, [
              (__props.data.thumbnail)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: __props.data.thumbnail,
                    alt: __props.data.name,
                    onError: _cache[0] || (_cache[0] = (e) => (e.target as HTMLImageElement).style.display='none')
                  }, null, 40, _hoisted_4))
                : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_unref(initials)(__props.data.name)), 1))
            ], 4),
            _createElementVNode("span", {
              class: _normalizeClass(["asm-avail-dot", __props.data.availability || 'offline'])
            }, null, 2)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, _toDisplayString(__props.data.name), 1),
            _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(profileLabel)(__props.data.id, __props.data.teamIds ?? [])), 1),
            _createElementVNode("div", _hoisted_9, _toDisplayString(__props.data.email), 1),
            (openCount.value > 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_10, [...(_cache[3] || (_cache[3] = [
                  _createElementVNode("svg", {
                    width: "9",
                    height: "9",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "2.5",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  }, [
                    _createElementVNode("path", { d: "M3 18v-6a9 9 0 0 1 18 0v6" }),
                    _createElementVNode("path", { d: "M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zM3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z" })
                  ], -1),
                  _createTextVNode(" em atendimento ", -1)
                ]))]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("button", {
            class: "asm-close",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
          }, [...(_cache[4] || (_cache[4] = [
            _createElementVNode("svg", {
              width: "14",
              height: "14",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2.5",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, [
              _createElementVNode("line", {
                x1: "18",
                y1: "6",
                x2: "6",
                y2: "18"
              }),
              _createElementVNode("line", {
                x1: "6",
                y1: "6",
                x2: "18",
                y2: "18"
              })
            ], -1)
          ]))])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, _toDisplayString(__props.data.conversations.length), 1),
            _cache[5] || (_cache[5] = _createElementVNode("div", { class: "asm-stat-l" }, "Total", -1))
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, _toDisplayString(openCount.value), 1),
            _cache[6] || (_cache[6] = _createElementVNode("div", { class: "asm-stat-l" }, "Abertas", -1))
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, _toDisplayString(pendingCount.value), 1),
            _cache[7] || (_cache[7] = _createElementVNode("div", { class: "asm-stat-l" }, "Pendentes", -1))
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, _toDisplayString(resolvedCount.value), 1),
            _cache[8] || (_cache[8] = _createElementVNode("div", { class: "asm-stat-l" }, "Resolvidas", -1))
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, _toDisplayString(resolutionRate.value), 1),
            _cache[9] || (_cache[9] = _createElementVNode("div", { class: "asm-stat-l" }, "Taxa Resolução", -1))
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, _toDisplayString(avgTime.value), 1),
            _cache[10] || (_cache[10] = _createElementVNode("div", { class: "asm-stat-l" }, "Tempo Médio", -1))
          ])
        ]),
        (teamNames.value.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(teamNames.value, (t) => {
                return (_openBlock(), _createElementBlock("span", {
                  key: t,
                  class: "asm-team-chip"
                }, _toDisplayString(t), 1))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("div", _hoisted_26, [
            _cache[11] || (_cache[11] = _createTextVNode(" Conversas ", -1)),
            _createElementVNode("span", _hoisted_27, _toDisplayString(__props.data.conversations.length), 1)
          ]),
          (!__props.data.conversations.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_28, "Nenhuma conversa atribuída"))
            : (_openBlock(), _createElementBlock("div", _hoisted_29, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.data.conversations, (c) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: c.id,
                    class: "asm-conv-row"
                  }, [
                    _createElementVNode("span", _hoisted_30, "#" + _toDisplayString(c.id), 1),
                    _createElementVNode("div", _hoisted_31, [
                      _createElementVNode("div", _hoisted_32, _toDisplayString(c.contact.name), 1),
                      _createElementVNode("div", _hoisted_33, _toDisplayString(c.contact.phone), 1)
                    ]),
                    _createElementVNode("span", {
                      class: _normalizeClass(["status-pill", c.status]),
                      style: {"font-size":"10px"}
                    }, [
                      _cache[12] || (_cache[12] = _createElementVNode("span", { class: "sdot" }, null, -1)),
                      _createTextVNode(_toDisplayString(statusLabel(c.status)), 1)
                    ], 2),
                    _createElementVNode("span", _hoisted_34, _toDisplayString(c.team?.name || '—'), 1),
                    _createElementVNode("button", {
                      class: "open-chat-btn",
                      title: "Abrir chat",
                      onClick: ($event: any) => (_ctx.$emit('openChat', c))
                    }, [...(_cache[13] || (_cache[13] = [
                      _createElementVNode("svg", {
                        width: "13",
                        height: "13",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        stroke: "currentColor",
                        "stroke-width": "2",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      }, [
                        _createElementVNode("path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" })
                      ], -1)
                    ]))], 8, _hoisted_35)
                  ]))
                }), 128))
              ]))
        ])
      ])
    ])
  ]))
}
}

})